export default __webpack_public_path__ + "static/carousel-17-9138fc43528404ad1756ec43fd24e507.jpg";